/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

const B_Button = (function(superclass){

    // [D]

	return class extends superclass {

		constructor(obj) {
			super(obj);

			// [S]
			this._container.cursor = "pointer";    // # cursor 처리
		}

		// [F] public

		/**
		 * @DES :: 클릭 메소드
		 * @IP1 :: cb[func] - 이벤트리스너 종료후에 처리
		 * @S.E ::
		 */
		click(cb) {
			this._container.on('click', (event) => {
				// [#] 활성화 판단
				if(this._active) { cb(event); }
			});
		}

		/**
		 * @DES :: 호버 메소드
		 * @IP1 :: cb[func] - 이벤트리스너 종료후에 처리
		 * @S.E ::
		 */
		rollover(cb) {
			this._container.on("rollover", () => {
				// [#] 활성화 판단
				if(this._active) { cb(); }
			});
		}

		/**
		 * @DES :: 호버 메소드
		 * @IP1 :: cb[func] - 이벤트리스너 종료후에 처리
		 * @S.E ::
		 */
		rollout(cb) {
			this._container.on("rollout", () => {
				// [#] 활성화 판단
				if(this._active) { cb(); }
			});
		}
		
	}
});

export default B_Button;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/button/B_Button.js